export default __webpack_public_path__ + "static/autobell-logo-859f6264d711a3d4c082f8f8a3c441e4.png";